import { render, staticRenderFns } from "./DeliveryBlockTransporter.vue?vue&type=template&id=22884d01&"
import script from "./DeliveryBlockTransporter.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockTransporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports